import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

const Lightbox = ({ hotspots, setStep }) => {
  if (!hotspots || hotspots.length < 1) return null;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1312 900" css={styles.svg}>
      {hotspots.map(({ goTo, x, y }, index) => (
        <path
          key={index}
          onClick={() => setStep(goTo)}
          css={styles.hotspot}
          d={`M ${x} ${y + 20} a 20 20 0 1 1 20 -20 A 20.0229 20.0229 0 0 1 ${x} ${
            y + 20
          } Z m 0 -39 a 19 19 0 1 0 19 19 A 19.0216 19.0216 0 0 0 ${x} ${
            y - 19
          } Z m -0.0001 3.0001 a 16 16 0 1 1 -16 16 A 16 16 0 0 1 ${x} ${y - 16} Z`}
        />
      ))}
    </svg>
  );
};

const styles = {
  svg: css`
    position: absolute;
    inset: 0;
  `,
  hotspot: css`
    fill: var(--color-interactive);
    cursor: pointer;
    transform-box: fill-box;
    transform-origin: center;
    animation: pulse 1250ms ease-in-out infinite alternate;
    transition: fill 70ms cubic-bezier(0, 0, 0.38, 0.9);

    &:hover {
      fill: var(--color-hover);
    }

    @keyframes pulse {
      from {
        transform: scale(1.25);
        opacity: 0.6;
      }

      to {
        transform: scale(1.5625);
        opacity: 0.4;
      }
    }
  `,
};

Lightbox.propTypes = {
  hotspots: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      goTo: PropTypes.func.isRequired,
    }),
  ),
  setStep: PropTypes.func.isRequired,
};

export default Lightbox;
